import { render, staticRenderFns } from "./LgFinderPageProcessoCompra.vue?vue&type=template&id=2fd3b94c"
import script from "./LgFinderPageProcessoCompra.vue?vue&type=script&lang=js"
export * from "./LgFinderPageProcessoCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports